import { render, staticRenderFns } from "./ChildrenWorksDetail.vue?vue&type=template&id=4437b4ec&scoped=true"
import script from "./ChildrenWorksDetail.vue?vue&type=script&lang=js"
export * from "./ChildrenWorksDetail.vue?vue&type=script&lang=js"
import style0 from "./ChildrenWorksDetail.vue?vue&type=style&index=0&id=4437b4ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4437b4ec",
  null
  
)

export default component.exports